// 헤드 타이틀 태그용 언어팩
// 디렉토리 명을 따른다.
export default {
    app: "허브컨트롤룸",
    welcome: "메인",
    login: "로그인",
    barogo_notice: "바로고 공지사항",
    member_company_inquiry: "회원사 업무문의",
    distributor_notice: "총판점 공지사항",
    store_work_process: "상점 업무처리",
    worker_notice: "라이더 공지사항",
    request_map: "세부지명 요청",
    report_download: "정산서 다운로드",
    baromoney_transfer_setting: "캐쉬 이동 설정",
    baromoney_account_receivable_list: "캐쉬이동 미수금 리스트",
    baromoney_accrued_expenses_list: "캐쉬이동 미지급 리스트",
    map_control: "지도관제",
    delivery_history: "배달내역",
    operation_setting: "운행설정",
    list_control: "목록관제",
    store_management: "상점 관리",
    store_adjustment: "상점 정산",
    store_stats: "상점 통계",
    worker_management: "라이더 관리",
    worker_baromoney_history: "라이더 바로머니 내역",
    worker_profit: "라이더 수익",
    worker_monthly_attendance: "라이더 출근표",
    worker_adjustment: "라이더 정산",
    worker_statistics: "라이더 통계",
    hub_management: "허브 관리",
    hub_adjustment: "허브 정산",
    hub_stats: "허브 통계",
    hub_adjustment_test_mode_entrance: "허브 정산 테스트 모드",
    user_management: "사용자 관리",
    policy_delivery_amount: "배달대행료 관리",
    share_management: "공유 관리",
    delivery_charge_area_control: "구역 설정",
    sales: "매출",
    baromoney_report: "바로머니 리포트",
    withdrawal_request: "출금요청",
    worker_allocate: "라이더 배차",
    location_control: "출발도착관제",
    temporary: "임시",
    temporary2: "임시2",
    design_system: "디자인 시스템",
};
